import React from 'react'

function ToggleSwitch() {
  return (
    <div>ToggleSwitch</div>
  )
}

export default ToggleSwitch